module.exports = __webpack_public_path__ + "img/alipay.074f9d41.svg";